import {BindingOptions} from 'vuex-class/lib/bindings'

export class StoreNamespace {
    public static readonly AUTHENTICATION_MODULE: string = 'authentication'
    public static readonly AUTHORIZATION_MODULE: string = 'authorization'
    public static readonly LOBBY_MODULE: string = 'lobby'
    public static readonly SEARCH_MODULE: string = 'search'
    public static readonly DOCS_MODULE: string = 'documents'
    public static readonly PROCESSES_MODULE: string = 'processes'
    public static readonly MEMBERS_MODULE: string = 'members'
    public static readonly CREDIT_INDICATION: string = 'credit'
    public static readonly ACTIVITY_LOANS: string = 'loans'
    public static readonly ENTITLEMENT_SIMULATOR: string = 'entitlement'
    public static readonly LOAN_CONFIGURATION: string = 'loanConfiguration'
    public static readonly MESSAGES_AND_LETTERS_MODULE: string = 'messagesAndLetters'
    public static readonly CUSTOMER_SERVICE_MODULE: string = 'customerService'
    public static readonly PROCESSES_MANAGEMENT_MODULE: string = 'processesManagement'
    public static readonly ARCHIVE_DOCUMENTS_OPENER_MODULE: string = 'archiveDocumentsOpener'
    public static readonly FUND_MODULE: string = 'fund'

    public static readonly AUTHENTICATION: BindingOptions = {namespace: StoreNamespace.AUTHENTICATION_MODULE}
    public static readonly AUTHORIZATION: BindingOptions = {namespace: StoreNamespace.AUTHORIZATION_MODULE}
    public static readonly LOBBY: BindingOptions = {namespace: StoreNamespace.LOBBY_MODULE}
    public static readonly SEARCH: BindingOptions = {namespace: StoreNamespace.SEARCH_MODULE}
    public static readonly DOCS: BindingOptions = {namespace: StoreNamespace.DOCS_MODULE}
    public static readonly PROCESSES: BindingOptions = {namespace: StoreNamespace.PROCESSES_MODULE}
    public static readonly MEMBERS: BindingOptions = {namespace: StoreNamespace.MEMBERS_MODULE}
    public static readonly CREDIT: BindingOptions = {namespace: StoreNamespace.CREDIT_INDICATION}
    public static readonly LOANS: BindingOptions = {namespace: StoreNamespace.ACTIVITY_LOANS}
    public static readonly ENTITLEMENT: BindingOptions = {namespace: StoreNamespace.ENTITLEMENT_SIMULATOR}
    public static readonly LOAN_CONFIG: BindingOptions = {namespace: StoreNamespace.LOAN_CONFIGURATION}
    public static readonly MESSAGES_AND_LETTERS: BindingOptions = {namespace: StoreNamespace.MESSAGES_AND_LETTERS_MODULE}
    public static readonly CUSTOMER_SERVICE: BindingOptions = {namespace: StoreNamespace.CUSTOMER_SERVICE_MODULE}
    public static readonly PROCESSES_MANAGEMENT: BindingOptions = {namespace: StoreNamespace.PROCESSES_MANAGEMENT_MODULE}
    public static readonly ARCHIVE_DOCUMENTS_OPENER: BindingOptions = {namespace: StoreNamespace.ARCHIVE_DOCUMENTS_OPENER_MODULE}
    public static readonly FUND: BindingOptions = {namespace: StoreNamespace.FUND_MODULE}

    public static readonly ACCESS_TOKEN_GETTER: string = StoreNamespace.AUTHORIZATION_MODULE + '/accessToken'
}
